<!-- Die mobile ansicht ist direkt in product-detail.components.html -->
<div
  (click)="handleExperience()"
  [ngClass]="{ open: experienceOpen, 'bg-transparent': !experienceOpen }"
  class="boxed experience outer show-for-m"
>
  <div class="spacerfront" [ngClass]="{ hidden: !experienceOpen }"></div>

  <div class="grid px22">
    <div
      class="xs-6 m-6 l-8 ml13"
      [ngClass]="{
        'bg-transparent': !experienceOpen,
        'bg-vb': experienceOpen,
        innerbt: experienceOpen
      }"
    ></div>
    <div
      class="align-spaced align-center inner innerbt ml13 xs-6 m-6 l-4"
      [ngClass]="{
        innerbl: !experienceOpen
      }"
    >
      <div class="flex-container align-spaced align-center pointer bg-vb pad">
        <h1 class="text-white">
          {{ "experience-the-product.experience-product" | i18next }}
        </h1>
        <div>
          <svg
            height="10.103"
            viewBox="0 0 18.76 10.103"
            width="18.76"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              data-name="Gruppe 333"
              id="Gruppe_333"
              transform="translate(0 0)"
            >
              <g
                data-name="Gruppe 332"
                id="Gruppe_332"
                transform="translate(0 0)"
              >
                <path
                  d="M18.55,8.871,9.891.212a.719.719,0,0,0-1.02,0L.211,8.871A.722.722,0,0,0,.72,10.1a.713.713,0,0,0,.511-.212L9.38,1.743,17.53,9.891a.718.718,0,0,0,1.02,0,.723.723,0,0,0,0-1.02"
                  data-name="Pfad 160"
                  fill="#ffffff"
                  id="Pfad_160"
                  transform="translate(0 0.001)"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
  <div class="spacerback"></div>
  <div #content class="content">
    <div class="grid squares">
      <div *ngIf="productData.images.freestanding_1" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.freestanding_1)"
        >
          <img
            src="{{ productData.images.freestanding_1 | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.freestanding_2" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.freestanding_2)"
        >
          <img
            src="{{ productData.images.freestanding_2 | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.freestanding_3" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.freestanding_3)"
        >
          <img
            src="{{ productData.images.freestanding_3 | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.freestanding_mood_1" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.freestanding_mood_1)"
        >
          <img
            src="{{ productData.images.freestanding_mood_1 | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.freestanding_mood_2" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.freestanding_mood_2)"
        >
          <img
            src="{{ productData.images.freestanding_mood_2 | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.freestanding_mood_3" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.freestanding_mood_3)"
        >
          <img
            src="{{ productData.images.freestanding_mood_3 | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.milieu_1" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.milieu_1)"
        >
          <img src="{{ productData.images.milieu_1 | image }}" loading="lazy" />
        </button>
      </div>
      <div *ngIf="productData.images.usp_design_1" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.usp_design_1)"
        >
          <img
            src="{{ productData.images.usp_design_1 | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.usp_function_1" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.usp_function_1)"
        >
          <img
            src="{{ productData.images.usp_function_1 | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.usp_function_2" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.usp_function_2)"
        >
          <img
            src="{{ productData.images.usp_function_2 | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.usp_function_3" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.usp_function_3)"
        >
          <img
            src="{{ productData.images.usp_function_3 | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.in_use_1" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.in_use_1)"
        >
          <img src="{{ productData.images.in_use_1 | image }}" loading="lazy" />
        </button>
      </div>
      <div *ngIf="productData.images.usp_design_2" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.usp_design_2)"
        >
          <img
            src="{{ productData.images.usp_design_2 | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.in_use_2" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.in_use_2)"
        >
          <img src="{{ productData.images.in_use_2 | image }}" loading="lazy" />
        </button>
      </div>
      <div *ngIf="productData.images.milieu_2" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.milieu_2)"
        >
          <img src="{{ productData.images.milieu_2 | image }}" loading="lazy" />
        </button>
      </div>
      <div *ngIf="productData.images.collection" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.collection)"
        >
          <img
            src="{{ productData.images.collection | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.packaging" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.packaging)"
        >
          <img
            src="{{ productData.images.packaging | image }}"
            loading="lazy"
          />
        </button>
      </div>
      <div *ngIf="productData.images.logo" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.logo)"
        >
          <img src="{{ productData.images.logo | image }}" loading="lazy" />
        </button>
      </div>
      <div *ngIf="productData.images.gift" class="xs-6 m-3 item">
        <button
          type="button"
          (click)="openLightbox($event, productData.images.gift)"
        >
          <img src="{{ productData.images.gift | image }}" loading="lazy" />
        </button>
      </div>
    </div>
  </div>
</div>
